module.exports = __webpack_public_path__ + "static/img/t27.40f9ca33.png";